import React from 'react';
import intl from 'react-intl-universal';
import { Button } from 'semantic-ui-react';
import ExportButton from 'components/Common/ExportButton';
import ToolBarButton from 'components/Common/ToolbarButton';

interface Props {
  handleExportData: () => void;
  addMeetingModalOpen: () => void;
  deleteMeetings: (arg: Array<string>) => void;
  selectionArray: Array<string>;
  resetExportState: () => void;
  isExporting: boolean;
}

class MeetingsToolbar extends React.Component<Props> {
  componentDidMount(): void {
    this.props.resetExportState();
  }

  render() {
    const { addMeetingModalOpen, handleExportData, selectionArray, deleteMeetings, isExporting } = this.props;

    return (

      <div>
        <ExportButton
          data-test="toolbarBtn.exportAll"
          disabled={false}
          isExporting={isExporting}
          onExportClick={handleExportData}
        />
        <Button
          data-test="toolbarBtn.createMeeting"
          disabled={false}
          id="btnAddMeeting"
          name="btnAddMeeting"
          onClick={addMeetingModalOpen}
          role="button"
          type="button"
        >
          {intl.get('createMeeting')}
        </Button>
        <ToolBarButton
          clickHandler={() => { deleteMeetings(selectionArray); }}
          data-test="toolbarBtn.deleteMeeting"
          disabledTooltipText={intl.get('tooltipMeetingDisabledText')}
          isEnabled={selectionArray.length > 0}
          label={intl.get('delete')}
          tooltipIsOnRight={true}
          warningTooltipText={''}
        />
      </div>
    );
  }
}

export default MeetingsToolbar;
